import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Loader from '../UI/Loader.jsx'

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, userType, loading } = useSelector((state) => state.auth)
  const location = useLocation()

  // Show loader while checking authentication
  if (loading) {
    return <Loader message="Checking authentication..." />
  }

  // Check if authenticated
  if (!isAuthenticated) {
    // Store the attempted URL for redirect after login
    sessionStorage.setItem('redirectAfterLogin', location.pathname)

    // Redirect to appropriate login based on the route
    if (location.pathname.startsWith('/super-admin')) {
      return <Navigate to="/super-admin/login" state={{ from: location }} replace />
    } else if (location.pathname.startsWith('/org')) {
      return <Navigate to="/org/login" state={{ from: location }} replace />
    } else {
      return <Navigate to="/login" state={{ from: location }} replace />
    }
  }

  // Check role-based access
  if (allowedRoles.length > 0 && !allowedRoles.includes(userType)) {
    return <Navigate to="/" replace />
  }

  return children
}

export default ProtectedRoute